import { ReactNode } from 'react';
import { useTheme } from 'styled-components';
import Text12 from '@sdk/components/ui/typography/Text12';
import Row from '@sdk/components/ui/spacing/Row';
import StyledSvg from '@sdk/components/ui/StyledSvg';
import { SvgComponentType } from '@sdk/types';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import {
  RowContainer,
  LabelSection,
  ContentSection,
} from '@web/timeClock/modals/rows/ModalRow/modalRow.styles';

type Props = {
  label: string;
  icon: SvgComponentType;
  children: ReactNode;
};

const ModalRow = ({ label, icon, children }: Props) => {
  const theme = useTheme();
  return (
    <RowContainer>
      <LabelSection>
        <Text12 bold themeColor={ThemeColorType.gray} uppercase mTop={7}>
          {label}
        </Text12>

        <Row mLeft={10} mRight={10}>
          <StyledSvg svg={icon} color={theme.colors[ThemeColorType.iconGray]} />
        </Row>
      </LabelSection>
      <ContentSection alignItems="center">{children}</ContentSection>
    </RowContainer>
  );
};

export default ModalRow;
